import { render, staticRenderFns } from "./bankVerifyCode.vue?vue&type=template&id=0562fd30"
import script from "./bankVerifyCode.vue?vue&type=script&lang=js"
export * from "./bankVerifyCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports